import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

import { getConfig } from "../config/env.config";

const { apiBaseUrl } = getConfig();

class FluentAxios {
  private axiosInstance: AxiosInstance;

  constructor(baseURL: string = apiBaseUrl) {
    this.axiosInstance = axios.create({
      baseURL,
      timeout: 100000,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  }

  useLeadEndpoint(): FluentAxios {
    return new FluentAxios(apiBaseUrl);
  }

  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.get<T>(`${url}`, config);
  }

  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.post<T>(`${url}`, data, config);
  }

  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.put<T>(`${url}`, data, config);
  }

  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.delete<T>(`${url}`, config);
  }
}
const axiosInstance = new FluentAxios();
(globalThis as any).axiosInstance = axiosInstance;

export default axiosInstance;
